import attachEnterAsClick from 'utils/attachEnterAsClick';
import $ from 'jquery';

const onDonateSubmit = ($quickDonate, $quickDonateSubmit) => {
    // eslint-disable-next-line
    $quickDonateSubmit.on('click', function(e) {
        e.preventDefault();

        const dType = $('.donate-hidden-freq').val();
        const dAmt = $('.donate-hidden-amount').val();

        if (dType !== '' && dAmt !== '') {
            // eslint-disable-next-line
            sessionStorage.setItem('dType', Base64.encode(dType));
            // eslint-disable-next-line
            sessionStorage.setItem('dAmt', Base64.encode(dAmt));

            if ($quickDonate.find('.js-disable-submit').length > 0) return;

            // eslint-disable-next-line
            javascript: __doPostBack('DonateButton', 'Click');
        }
    });
};

const quickDonate = () => {
    // allow only 2 decimal numbers
    const regex = /^\d*\.?\d{0,2}$/;

    // Check if we have notification on the page
    const $quickDonate = $('.s-quick-donate');

    if (!$quickDonate.length) { return; }

    $quickDonate.keypress(e => {
        const $el = $(e.target);
        const event = e || window.event;
        const charCode = (typeof event.which === 'undefined') ? event.keyCode : event.which;
        const charStr = String.fromCharCode(charCode);
        const val = $el.val().toLowerCase() + charStr.toLowerCase();

        // test digit
        if (regex.test(val)) {
            if ($el.closest('.donate-amount-input').length > 0) {
                if (val.startsWith('0')) return false;
            }

            return true;
        }

        return false;
    });

    let emptyFieldMessage = '';
    const $quickDonateSubmit = $quickDonate.find('.js-quick-donate-trigger');
    const $quickAmount = $quickDonate.find('.dollar-amount input');
    const $quickHiddenAmount = $quickDonate.find('.donate-hidden-amount');
    const $quickDonateWrapper = $quickDonate.find('.donate-form-wrapper');
    const minDonation = parseInt($quickDonateWrapper.attr('data-min-donate'), 0);
    const $errorMessage = $('<div>', { class: 'has-error js-disable-submit' });

    $quickAmount.keyup(e => {
        const $this = $(e.target);
        $quickHiddenAmount.val($this.val());
    });

    $quickDonateSubmit.click(() => {
        const donationAmount = parseInt($quickAmount.val(), 0);
        $quickDonateWrapper.find('.textbox-wrapper .has-error').remove();

        if ($quickAmount.val() === '') {
            emptyFieldMessage = 'Please enter a valid amount';
            $errorMessage.appendTo($quickDonateWrapper.find('.textbox-wrapper'));
        } else if (minDonation > donationAmount) {
            emptyFieldMessage = `The minimum donation amount is $${minDonation}`;
            $errorMessage.appendTo($quickDonateWrapper.find('.textbox-wrapper'));
        }

        $('.textbox-wrapper .has-error').text(emptyFieldMessage);
    });

    onDonateSubmit($quickDonate, $quickDonateSubmit);

    attachEnterAsClick($quickDonateSubmit);
};

$(() => {
    quickDonate();
});



// WEBPACK FOOTER //
// ./src/sections/quick-donate/s-quick-donate.js